import AppContent from './AppContent';
import { ToastProvider } from './components/ToastProvider';

const App = () => {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  );
};

export default App;
